function FullLoader() {
  return (
    <div className='full-loader'>
      <span className='loader'></span>
    </div>
  )
}

export default FullLoader
